import { useQuery, useMutation } from 'react-query';

import { getUser, loginUser, createUser } from './queries';

export const useUser = (config) => useQuery('user', getUser, config);

export const useLoginUser = (config) => useMutation(loginUser, config, false);

export const useCreateUser = (config) => useMutation(createUser, config, false);
